interface CheckoutCustomization {
  expandProductList?: boolean;
}

export function getCheckoutCustomization(): CheckoutCustomization {
  const searchParams = new URLSearchParams(window.location.search);
  const customizationParams = searchParams.get('customization') || '';
  let parsedCustomization: CheckoutCustomization = {};

  try {
    parsedCustomization = JSON.parse(customizationParams);
  } catch (error) {
    //console.error(error);
  }
  return {
    expandProductList: parsedCustomization?.expandProductList,
  };
}
